import * as React from "react";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/components/Dialog/";
import { PrimaryButton } from "@fluentui/react/lib/components/Button/PrimaryButton/PrimaryButton";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import { Checkbox } from "@fluentui/react/lib/components/Checkbox/Checkbox";

class WelcomeDialog extends React.Component {
  state = {
      isDialogHidden: true
  }

  componentDidMount() {
      console.log("start componentDidMount");
      const localStorageFlag: boolean = LocalCacheHelper.GetLocalStorageItemCpbxHideWelcomeDialog();
      console.log("localStorageFlag='" + localStorageFlag + "'");
      this.setState({
          isDialogHidden: localStorageFlag

      });
  }

  private onClickActionButtonClose = (): void => {
      console.log("onClickActionButtonClose");
      this.setState({
          isDialogHidden: true
      });
  };

  private onChangeDoNotSchow = (ev, val: boolean = false): void => {
      console.log("onChangeDoNotSchow: ", val);
      LocalCacheHelper.SetLocalStorageItemCpbxHideWelcomeDialog(val);
  };

  render() {
      const dialogContentProps = {
          type: DialogType.normal,
          title: "Herzlich willkommen",
          subText: "Die Cloud PBX App steht Ihnen kostenlos zur Verfügung.",
          closeButtonAriaLabel: "Close",
          showCloseButton: true
      };

      return (
          <div>
              <Dialog
                  hidden={this.state.isDialogHidden}
                  dialogContentProps={dialogContentProps}
                  minWidth={600}
                  onDismiss={this.onClickActionButtonClose}
                  className={"cpbxDialogContainer"}
                  modalProps={{ isBlocking: true }}
              >
                  <p className="cpbxDialogParagraph">
            Für die Nutzung der Telekom Cloud PBX ist ein bestehender
            CompanyFlex-Vertrag erforderlich. Weitere Information finden Sie
            unter dem Reiter FAQ, kontaktieren Sie uns{" "}
                      <a
                          className="cpbxDialogMailto"
                          href="mailto:cloudpbxapp.msteams@telekom.de?Subject=Kontaktaufnahme zur Telekom Cloud PBX App"
                      >
              per Mail
                      </a>{" "}
            oder der Rufnummer{" "}
                      <a
                          className="cpbxDialogMailto"
                          href="tel:08003306708"
                          target="_blank"
                          rel="noopener noreferrer"
                      >
              0800 330 6708
                      </a>{" "}
                  </p>

                  <DialogFooter>
                      <Checkbox
                          label="Nicht mehr anzeigen"
                          onChange={this.onChangeDoNotSchow}
                      />
                      <PrimaryButton
                          onClick={this.onClickActionButtonClose}
                          text="Jetzt starten"
                      />
                  </DialogFooter>
              </Dialog>
          </div>
      );
  }
}
export default WelcomeDialog;
